import { render, staticRenderFns } from "./CompanyView.vue?vue&type=template&id=bc0ee95e&scoped=true"
import script from "./CompanyView.vue?vue&type=script&lang=js"
export * from "./CompanyView.vue?vue&type=script&lang=js"
import style0 from "./CompanyView.vue?vue&type=style&index=0&id=bc0ee95e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0ee95e",
  null
  
)

export default component.exports